import jsCookie from 'js-cookie'

const USER_COOKIE = 'holacon-mediaservices.user'
const DEVICES_COOKIE = 'holacon-mediaservices.devices'

export function getUser() {
  return jsCookie.getJSON(USER_COOKIE)
}

export function setUser({ displayName }) {
  jsCookie.set(USER_COOKIE, { displayName })
}

export function getDevices() {
  return jsCookie.getJSON(DEVICES_COOKIE)
}

export function setDevices({ webcamEnabled }) {
  jsCookie.set(DEVICES_COOKIE, { webcamEnabled })
}



//////////////////
// WEBPACK FOOTER
// ./utils/cookiesManager.js
// module id = null
// module chunks = 